var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-to-top",class:{ 'visible': _vm.isVisible },on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"icon-arrow-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }